import gql from 'graphql-tag';

const mutation = gql`
  mutation AddUserLicense($params: AddUserLicenseParams!) {
    addUserLicense(params: $params)
  }
`;

export default mutation;
